import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import Icon from '../Shared/Icons';
import { useAuth } from '../../context/AuthContext';
import { getProgram, MEMBER_TYPES } from '../../config/programs';
import { fetchMembers, fetchReports } from '../../utils/programData';
import { isoWeekKey, weekLabel, shiftWeeks, daysLeftInWeek } from '../../utils/weekUtils';
import { ProgramShell, S, T } from './ui';

// ── BODI YA WIKI ────────────────────────────────────────────────────────
// Hii ndio inayozuia staff wawili kuandika ripoti ya mtu mmoja.
// Kila staff anaona: nani ameandikiwa, na NANI ndiye aliyemwandikia.
// Akitaka kuongeza kitu, anafungua ripoti ileile na kuweka nyongeza.

export default function WeeklyBoard() {
  const { pid } = useParams();
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const program = getProgram(pid);

  const [anchor, setAnchor] = useState(new Date());
  const [members, setMembers] = useState([]);
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all'); // all | pending | mine
  const [search, setSearch] = useState('');

  const wk = isoWeekKey(anchor);
  const isCurrentWeek = wk === isoWeekKey();

  useEffect(() => { if (program) load(); /* eslint-disable-next-line */ }, [pid, wk]);

  async function load() {
    setLoading(true);
    try {
      const [ms, rs] = await Promise.all([
        fetchMembers(pid),
        fetchReports({ programId: pid, kind: 'individual', weekKey: wk }),
      ]);
      setMembers(ms);
      setReports(rs);
    } catch (e) { console.error(e); }
    setLoading(false);
  }

  if (!program) return <Navigate to="/programs" />;

  const byMember = {};
  reports.forEach(r => { byMember[r.memberId] = r; });

  const list = members.filter(m => {
    const r = byMember[m.id];
    if (filter === 'pending' && r) return false;
    if (filter === 'mine' && (!r || r.authorId !== currentUser?.uid)) return false;
    if (search.trim()) {
      const q = search.toLowerCase();
      if (!(m.fullName || '').toLowerCase().includes(q)) return false;
    }
    return true;
  });

  const done = reports.length;
  const total = members.length;

  return (
    <ProgramShell program={program} tab="week">

      {/* Kiongozi cha wiki */}
      <div style={S.card}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
          <button style={{ ...S.btnGhost, padding: '8px 13px' }} onClick={() => setAnchor(shiftWeeks(anchor, -1))}>‹</button>
          <div style={{ textAlign: 'center', flex: 1 }}>
            <div style={{ fontSize: '13.5px', fontWeight: 800, color: T.green }}>{weekLabel(anchor)}</div>
            <div style={{ fontSize: '11px', color: T.muted, marginTop: '3px' }}>
              {isCurrentWeek ? `Wiki ya sasa · siku ${daysLeftInWeek()} zimebaki` : wk}
            </div>
          </div>
          <button
            style={{ ...S.btnGhost, padding: '8px 13px', opacity: isCurrentWeek ? 0.35 : 1 }}
            disabled={isCurrentWeek}
            onClick={() => setAnchor(shiftWeeks(anchor, 1))}
          >›</button>
        </div>

        <div style={{ height: '9px', background: '#F0EEE7', borderRadius: '99px', marginTop: '14px', overflow: 'hidden' }}>
          <div style={{
            width: `${total ? (done / total) * 100 : 0}%`, height: '100%',
            background: done === total && total ? '#059669' : program.color, borderRadius: '99px',
          }} />
        </div>
        <div style={{ fontSize: '12px', color: T.muted, marginTop: '9px', textAlign: 'center' }}>
          Ripoti <strong style={{ color: T.ink }}>{done}</strong> kati ya <strong style={{ color: T.ink }}>{total}</strong>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '7px', marginBottom: '12px', flexWrap: 'wrap' }}>
        {[
          { k: 'all', l: `Wote (${members.length})` },
          { k: 'pending', l: `Bado (${total - done})` },
          { k: 'mine', l: 'Nilizoandika mimi' },
        ].map(f => (
          <button
            key={f.k}
            onClick={() => setFilter(f.k)}
            style={{
              padding: '8px 15px', borderRadius: '99px', cursor: 'pointer',
              border: `1px solid ${filter === f.k ? program.color : T.line}`,
              background: filter === f.k ? program.color : '#fff',
              color: filter === f.k ? '#fff' : T.muted,
              fontSize: '12px', fontWeight: 700, fontFamily: 'inherit',
            }}
          >{f.l}</button>
        ))}
      </div>

      <input
        style={{ ...S.input, marginBottom: '14px' }}
        placeholder="Tafuta jina..."
        value={search}
        onChange={e => setSearch(e.target.value)}
      />

      {loading ? (
        <div style={{ ...S.card, ...S.empty }}>Inapakia...</div>
      ) : list.length === 0 ? (
        <div style={{ ...S.card, ...S.empty }}>
          {members.length === 0
            ? 'Hakuna mwanachama kwenye programu hii bado.'
            : filter === 'pending'
              ? '🎉 Kila mtu ameandikiwa ripoti wiki hii!'
              : 'Hakuna anayeendana na kichujio hiki.'}
        </div>
      ) : list.map(m => {
        const r = byMember[m.id];
        const mine = r && r.authorId === currentUser?.uid;
        return (
          <div
            key={m.id}
            onClick={() => navigate(`/programs/${pid}/report/${m.id}?week=${wk}`)}
            style={{
              ...S.card, cursor: 'pointer', padding: '14px 16px',
              display: 'flex', alignItems: 'center', gap: '12px',
              borderLeft: `4px solid ${r ? '#059669' : '#E5E1D6'}`,
            }}
          >
            <div style={{
              width: '38px', height: '38px', borderRadius: '11px', flexShrink: 0,
              background: r ? '#ECFDF5' : '#FAF8F3',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <Icon name={r ? 'check' : 'clock'} size={16} color={r ? '#059669' : '#A8A29E'} />
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: '14px', fontWeight: 700, color: T.ink }}>{m.fullName}</div>
              <div style={{ fontSize: '11.5px', color: T.muted, marginTop: '3px' }}>
                {MEMBER_TYPES[m.type]?.label} · {m.school || m.centre || m.area || '—'}
              </div>
              {r ? (
                <div style={{ fontSize: '11.5px', marginTop: '5px', color: mine ? '#059669' : '#1565C0', fontWeight: 600 }}>
                  ✍️ Imeandikwa na {mine ? 'wewe' : r.authorName}
                  {r.contributions?.length ? ` · nyongeza ${r.contributions.length}` : ''}
                </div>
              ) : (
                <div style={{ fontSize: '11.5px', marginTop: '5px', color: '#D97706', fontWeight: 600 }}>
                  Bado hajaandikiwa
                </div>
              )}
            </div>

            <span style={{ color: T.muted, fontSize: '17px' }}>›</span>
          </div>
        );
      })}

      <div style={{ ...S.card, background: '#FAF8F3', fontSize: '12px', color: T.muted, lineHeight: 1.7 }}>
        <Icon name="info" size={13} color={T.orange} />{' '}
        <strong style={{ color: T.ink }}>Kwa nini bodi hii?</strong> Kila mtu ana ripoti <strong>MOJA</strong> kwa wiki.
        Ukifungua ripoti iliyoandikwa na staff mwingine, unaisoma na — kama una la kuongeza —
        unaweka <strong>nyongeza</strong> badala ya kuandika ripoti nyingine. Hivyo hakuna kazi inayorudiwa.
      </div>

    </ProgramShell>
  );
}
